import React, { useRef } from "react";

// Polished 6-digit code input: autofocus first cell, auto-advance, backspace
// moves back, full-code paste supported, auto-submit when all 6 filled.
export default function OtpInput({ value, onChange, onComplete, disabled, error }) {
  const refs = useRef([]);
  const digits = value.padEnd(6, " ").slice(0, 6).split("");

  const setChar = (i, ch) => {
    const arr = value.padEnd(6, " ").slice(0, 6).split("");
    arr[i] = ch;
    const next = arr.join("").replace(/\s/g, "");
    onChange(next);
    return next;
  };

  const handleChange = (i, e) => {
    const raw = e.target.value.replace(/\D/g, "");
    if (!raw) return;
    const ch = raw[raw.length - 1];
    const next = setChar(i, ch);
    if (i < 5) refs.current[i + 1]?.focus();
    if (next.length === 6) onComplete?.(next);
  };

  const handleKeyDown = (i, e) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const arr = value.padEnd(6, " ").slice(0, 6).split("");
      if (arr[i] && arr[i] !== " ") {
        arr[i] = " ";
        onChange(arr.join("").replace(/\s/g, ""));
      } else if (i > 0) {
        refs.current[i - 1]?.focus();
        const prev = value.padEnd(6, " ").slice(0, 6).split("");
        prev[i - 1] = " ";
        onChange(prev.join("").replace(/\s/g, ""));
      }
    }
    if (e.key === "ArrowLeft" && i > 0) refs.current[i - 1]?.focus();
    if (e.key === "ArrowRight" && i < 5) refs.current[i + 1]?.focus();
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData.getData("text") || "").replace(/\D/g, "").slice(0, 6);
    if (!pasted) return;
    onChange(pasted);
    const focusIdx = Math.min(pasted.length, 5);
    refs.current[focusIdx]?.focus();
    if (pasted.length === 6) onComplete?.(pasted);
  };

  return (
    <div className="flex justify-between gap-2 sm:gap-3" data-testid="otp-input">
      {digits.map((d, i) => (
        <input
          key={i}
          ref={(el) => (refs.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          autoFocus={i === 0}
          disabled={disabled}
          value={d === " " ? "" : d}
          onChange={(e) => handleChange(i, e)}
          onKeyDown={(e) => handleKeyDown(i, e)}
          onPaste={handlePaste}
          className={`h-14 w-full rounded-xl border text-center text-[22px] font-semibold text-[#F4F5F8] outline-none transition-all focus:border-[#6D5EF6] focus:ring-2 focus:ring-[#7C6BFF] disabled:opacity-50 ${
            error ? "border-red-400" : "border-[#2A3040]"
          }`}
        />
      ))}
    </div>
  );
}
